import { Fragment } from 'react';
import { Link } from 'react-router-dom';

import './breadcrumbs.scss';

export interface BreadcrumbItem {
	label: string;
	to?: string;
	current?: boolean;
}

interface BreadcrumbsProps {
	items: BreadcrumbItem[];
	separatorIconSrc?: string;
	className?: string;
}

export function Breadcrumbs({ items, separatorIconSrc, className }: Readonly<BreadcrumbsProps>) {
	if (items.length === 0) return null;

	const rootClassName = `breadcrumbs${className ? ` ${className}` : ''}`;

	return (
		<nav className={rootClassName} aria-label="breadcrumb">
			{items.map((item, index) => {
				const isLast = index === items.length - 1;
				const isCurrent = item.current ?? isLast;

				return (
					<Fragment key={`${item.label}-${index}`}>
						{item.to && !isCurrent ? (
							<Link className="breadcrumbs__link" to={item.to}>
								{item.label}
							</Link>
						) : (
							<span className={isCurrent ? 'breadcrumbs__current' : 'breadcrumbs__link'}>
								{item.label}
							</span>
						)}
						{!isLast && (
							<span className="breadcrumbs__separator" aria-hidden={true}>
								{separatorIconSrc ? <img src={separatorIconSrc} alt="" /> : '/'}
							</span>
						)}
					</Fragment>
				);
			})}
		</nav>
	);
}
